const $$splitComponentImporter = () => import('/opt/buildhome/repo/src/routes/pro/login.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/pro/login')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});